module.exports = __webpack_public_path__ + "img/bg-去下单@2x.ad477930.png";